var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-letter-icon",attrs:{"data-test-id":"circle-letter-icon"}},[_vm._v(_vm._s(_vm.getAlphabeticalIndex))])
}
var staticRenderFns = []

export { render, staticRenderFns }